import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const venueFeatures = [
  'Sistemleri güncel tutmak için canlı, kesintisiz yükseltmeler',
  'Arızaların etkisini minimize etmek için hızlı kurtarma yetenekleri',
  'Gerçek zamanlı uygulamaları desteklemek için yüksek performanslı depolama',
  'Konum bağımsız tüm mekan sitelerinde merkezi izleme',
];

const roboFeatures = [
  { icon: 'ri-eye-line', title: 'Merkezi "Tek Cam" Yönetim', desc: 'Tüm konumlar için görünürlük ve kontrol.' },
  { icon: 'ri-shield-check-line', title: 'Yerleşik Yedekleme ve Kurtarma', desc: 'Kritik veriyi üçüncü parti araç olmadan koruyun.' },
  { icon: 'ri-cpu-line', title: 'Verimli 2–3 Düğüm Yapılandırmaları', desc: 'Yeteneği feda etmeden uygun maliyetli dağıtım.' },
  { icon: 'ri-expand-left-right-line', title: 'Kolayca Yukarı veya Aşağı Ölçeklendirin', desc: 'Temel veri merkeziyle aynı yazılımı kullanın.' },
];

const edgeRequirements = [
  { icon: 'ri-wifi-line', title: 'Yüksek Kullanılabilirlik', desc: 'Merkezi müdahale olmadan sürekli çalışmayı sağlar.' },
  { icon: 'ri-database-2-line', title: 'Entegre Veri Koruması', desc: 'Hızlı kurtarma ve uçtaki iş yükleri için yüksek performansı minimize eder.' },
  { icon: 'ri-settings-4-line', title: 'Merkezi Yönetim Yetenekleri', desc: 'Operasyonları izler, bakımını yapar ve günceller, tek arayüzden.' },
  { icon: 'ri-brain-line', title: 'Uç İçin Özel, Optimize Edilmiş AI', desc: 'Bulut bağlantısına bağımlı olmadan gerçek zamanlı analitik, çıkarım ve makine öğrenimi.' },
];

const edgeJsonLd = { '@context': 'https://schema.org', '@type': 'SoftwareApplication', name: 'VergeOS Edge/ROBO', applicationCategory: 'BusinessApplication', operatingSystem: 'Any', description: 'Uzak ofis ve edge lokasyonlar için VergeOS. 2 düğümden başlayan minimal ayak izi, merkezi yönetim.', url: `${SITE_URL}/edge-robo` };

export default function EdgeROBOPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead title="Edge ve ROBO Dağıtımı | Uzak Ofis | VergeOS" description="Uzak ofis ve edge lokasyonlar için VergeOS. 2 düğümden başlayan minimal ayak izi, merkezi yönetim ve kolay dağıtım." keywords="edge computing, ROBO, uzak ofis, VergeOS, edge altyapı, branch office" canonicalPath="/edge-robo" jsonLd={edgeJsonLd} />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">BT Girişimleri</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              Mekanlar, Uzak Ofisler<br />ve <span className="text-[#e8600a]">Uç Bilişim</span> için VergeOS
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">Tüm Konumlar İçin Tek Platform</p>
          </div>
        </section>

        {/* Intro Banner */}
        <section className="py-10 bg-gray-50 border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <p className="text-gray-600 text-sm leading-relaxed">Büyük halka açık mekanlar, uzak şube ofisleri (ROBO) veya uç bilişim ortamları işletiyor olun, BT altyapınız yüksek performans, yerel dayanıklılık ve merkezi görünürlük sunmak zorundadır. VergeOS çekirdeğinden uca kadar her konum türünün paylaşılan ve benzersiz gereksinimlerini karşılayacak şekilde tasarlanmıştır.</p>
          </div>
        </section>

        {/* Venues */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <div className="inline-block bg-[#e8600a]/10 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-4">Mekanlar</div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Stadyumlar, Spor Salonları, Eğlence Merkezleri</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">Stadyumlar, eğlence kompleksleri, kumarhaneler ve perakende destinasyonları gibi mekanlar, nokta satış işlemlerini, biletleme, akış, güvenlik ve müşteri etkileşimini yönetmek için BT sistemlerine güvenir. Bu ortamlar iş saatleri boyunca kesinti kaldıramaz.</p>
                <ul className="space-y-3">
                  {venueFeatures.map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/a7e86d0db16f57eb07aa307b574f77e7.jpg" alt="Mekan BT Yönetimi" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* ROBO */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=remote%20branch%20office%20ROBO%20IT%20infrastructure%20showing%20VergeOS%202-3%20node%20configuration%20running%20without%20dedicated%20IT%20staff%2C%20centralized%20management%20single%20pane%20of%20glass%20dashboard%20with%20scale%20up%20down%20arrows%2C%20dark%20background%20orange%20highlights%20professional%20enterprise%20remote%20office%20technology&width=580&height=400&seq=edge_robo1&orientation=landscape" alt="ROBO Altyapısı" className="w-full h-full object-top" />
              </div>
              <div>
                <div className="inline-block bg-[#e8600a]/10 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-4">Uzak Ofis — Şube Ofisi (ROBO)</div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Şube Ofisleri Genellikle Özel BT Personeli Olmadan Çalışır</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">Şube ofisleri genellikle kullanılabilirliği korumak ve yönetmek için uzak yönetim gerektirir. VergeOS bu ihtiyaçları karşılar:</p>
                <div className="grid grid-cols-2 gap-4">
                  {roboFeatures.map(f => (
                    <div key={f.title} className="bg-white rounded-lg p-4 border border-gray-100">
                      <span className="w-7 h-7 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mb-2"><i className={`${f.icon} text-sm`}></i></span>
                      <p className="font-semibold text-[#1e293b] text-xs mb-1">{f.title}</p>
                      <p className="text-xs text-gray-600">{f.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Edge Computing */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <div className="inline-block bg-[#e8600a]/10 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-4">Uç Bilişim</div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Uç Konumlar Özelleştirilmiş Uygulamalar ve Yüksek BT Taleplerine Sahiptir</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">Uç konumlar genellikle özelleştirilmiş uygulamaları destekler ve merkezi müdahale olmadan sürekli çalışmayı sürdürürken yüksek BT altyapısı taleplerini karşılar. VergeOS bu ihtiyaçları karşılar:</p>
                <div className="grid grid-cols-2 gap-4">
                  {edgeRequirements.map(f => (
                    <div key={f.title} className="bg-[#f8fafc] rounded-lg p-4 border border-gray-100">
                      <span className="w-7 h-7 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mb-2"><i className={`${f.icon} text-sm`}></i></span>
                      <p className="font-semibold text-[#1e293b] text-xs mb-1">{f.title}</p>
                      <p className="text-xs text-gray-600">{f.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=edge%20computing%20VergeOS%20miniature%20server%20deployment%20two%20servers%20in%20a%20shoebox-sized%20form%20factor%20running%20full%20enterprise%20infrastructure%2C%20high%20availability%20integrated%20data%20protection%20and%20private%20optimized%20AI%20at%20the%20edge%20visualization%20dark%20background%20orange%20highlights&width=580&height=440&seq=edge_compute1&orientation=landscape" alt="Uç Bilişim" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-16 bg-[#f8fafc] border-y border-gray-200">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <p className="text-gray-600 text-sm mb-6">Müşteriler VergeOS\'u uçta verimliliği nedeniyle konuşlandırır; genellikle yalnızca iki mini sunucu kullanarak tam enterprise altyapı oluşturabilirler. VergeOS verimliliği sayesinde kuruluşlar bir parmak boyutunda güçlü bir veri merkezi oluşturabilir.</p>
            <div className="grid grid-cols-3 gap-8">
              {[{ metric: '2+', label: 'Sunucu ile tam altyapı' }, { metric: '1', label: 'Platform tüm konumlar için' }, { metric: '%100', label: 'Merkezi görünürlük' }].map(m => (
                <div key={m.label}>
                  <p className="text-3xl font-extrabold text-[#e8600a] mb-1">{m.metric}</p>
                  <p className="text-sm text-gray-600">{m.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
